import { Component } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { HttpAgentFaoService } from '../../../../service/http-agent.service';

@Component({
  selector: 'app-agent-fao-list',
  standalone: false,
  templateUrl: './agent-fao-list.component.html',
  styleUrl: './agent-fao-list.component.scss'
})
export class AgentFaoListComponent {
	data: AgentDto[] = [];
	constructor(private httpService: HttpAgentFaoService){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

}
